import React from "react";
import { parseClients } from "../presence";
import { useHomeLang } from "../homeLang";

const LABEL = { it: "Numero dei tuoi clienti", en: "Your number of clients" };

// PROTOTYPE (hero v2): the visitor's number of clients, typed into the
// headline. A text field with a numeric keypad, so browsers add no spinner
// and no scroll-wheel stepping. A hidden copy of the digits sizes the field
// to them exactly, so the first digit sits on the headline's own edge, and it
// keeps the number in the headline's text for anything that reads the markup
// without running it. Assistive technology reads the field instead. Once the
// visitor leaves it, it shows the number the page goes by (parseClients), so
// the headline never says one number and the hero another.
export default function ClientsInputV2({ value, onChange }) {
  const label = LABEL[useHomeLang()];
  return (
    <span className="hv-num">
      <span className="hv-num-sizer" aria-hidden="true">{value}</span>
      <input
        className="hv-num-field"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={4}
        autoComplete="off"
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
        onBlur={() => onChange(String(parseClients(value)))}
      />
    </span>
  );
}
